import React from 'react';
import '../css/dataTables.css';


const renderTableBody = (headers, data, action, edditAddres, deleteAddress) => {
    let body = "";

    body = data.map((register, index) => {

        return (
            <tr key={index}>
                <td>{register.Address || ""}</td>
                <td className="overflow-visible">{(register.Street ? register.Street : '') + ' ' + (register.Block ? register.Block : '') + '  ' + (register.City ? register.City : '') + ' ' + (register.ZipCode ? register.ZipCode : '') + ' ' + (register.State ? register.State : '') + ' ' + (register.Country ? register.Country : '') || ""}</td>
                <td style={{ textAlign: "center", width: 40 }}>
                    <button type="button" className="btn btn-sm "
                        onClick={() => action({ index })}
                        style={{ fontWeight: '500', backgroundColor: "transparent", color: "#EABF28" }}>
                        <i className="fas fa-check"></i>
                    </button>
                    {/* <button type="button" className="btn btn-sm "
                            onClick={() => edditAddres(index)}
                            style={{fontWeight: '500', backgroundColor: "transparent", color: "#EABF28"}}>
                        <i className="fa fa-pencil"></i>
                    </button> */}
                </td>
                <td style={{ textAlign: "center", width: 40 }}>
                    <button type="button" className="btn btn-sm " onClick={() => deleteAddress({ index })} style={{ fontWeight: '500', backgroundColor: "transparent", color: "#dc3545" }} title="Eliminar">
                        <i className="fas fa-trash"></i>
                    </button>
                </td>
            </tr>
        )
    })

    return body;
};

const renderTable = (headers, data, action, edditAddres, deleteAddress) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            <td className="sticky-header table-header-yellow ">{headers[0].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[1].title}</td>
            <td className="sticky-header table-header-yellow " style={{ width: 40 }}></td>
            <td className="sticky-header table-header-yellow " style={{ width: 40 }}></td>
        </tr>;
    }

    body = renderTableBody(headers, data, action, edditAddres, deleteAddress);

    let table = "";

    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{ width: '100%' }}>
                <thead className="table-header">
                    {header}
                </thead>
                <tbody>
                    {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderAddressesModal = (headers, data, action, edditAddres, deleteAddress) => {

    return renderTable(headers, data, action, edditAddres, deleteAddress);

}
